export const getValueFromConfig = (config: any[], code: string) => {
  const stringValue = config?.find(
    (config: { code: string; value: string }) => config.code === code,
  )?.value;

  const value = isNaN(Number(stringValue)) ? 0 : Number(stringValue);

  return value;
};
